import Model from 'flarum/common/Model';
export default class ParentSpecies extends Model {
  gbifId() {
    return Model.attribute('gbifId').call(this);
  }
  parentGbifId() {
    return Model.attribute('parentGbifId').call(this);
  }
  scientificName() {
    return Model.attribute('scientificName').call(this);
  }
  parentScientificName() {
    return Model.attribute('parentScientificName').call(this);
  }
}
flarum.reg.add('champis-species', 'common/models/ParentSpecies', ParentSpecies);